import api from '../api/api'

const SET_REWARDS = 'REWARDS/SET_REWARDS'
const SET_ANALYTICS = 'REWARDS/SET_ANALYTICS'

const initialState = {
  rewards: [],
  analytics: null,
}

const rewardsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_REWARDS: {
      return {
        ...state,
        rewards: action.data,
      }
    }
    case SET_ANALYTICS: {
      return {
        ...state,
        analytics: action.analytics,
      }
    }
    default:
      return state
  }
}

export const fetchRewardsHistory = ({
  buildingId,
  skip = 0,
  limit = 50,
  type,
  category,
  status,
  query,
  clientId,
}) => {
  return (dispatch) => {
    return api
      .fetchRewardsHistory({ buildingId, skip, limit, type, category, status, query, clientId })
      .then((res) => {
        dispatch({ type: SET_REWARDS, data: res.data.data })
        return Promise.resolve(res.data.count)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  }
}

export const fetchRewardsAnalytics =
  ({ buildingId, startDate, endDate }) =>
  (dispatch) => {
    return api
      .fetchRewardsAnalytics({ buildingId, startDate, endDate })
      .then((res) => {
        dispatch({ type: SET_ANALYTICS, analytics: res.data })
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  }

export const createGiftCard = (data, type) => {
  return () => {
    let promise
    switch (type) {
      case 'external':
        promise = api.createExternalGiftCard(data)
        break
      case 'custom':
        promise = api.createCustomGiftCard(data)
        break
      case 'link':
        promise = api.createCashRewardLink(data)
        break
      default:
        return Promise.reject(new Error('Invalid gift card type'))
    }

    return promise
      .then((res) => {
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  }
}

export const selectRewards = (state) => state.rewards.rewards

export const selectRewardsAnalytics = (state) => state.rewards.analytics

export default rewardsReducer
